import api from "../../index";

export const GetAllUsersApi = (params) => api.get(`admin/getalluserlist?${params}`);
export const GetAllNotificationsApi = (params) => api.get(`notification/get-all-messages?${params}`);
export const DeleteNotificationsApi = (notificationId) => api.delete(`notification/clear-all-notifications/${notificationId}`);
export const AddNotificationApi = (data, headers) => api.post('notification/send-notification', data, headers);